<script setup lang="ts">
import { selectionActions } from "@/action/selectionActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";

import ShareMenu from "./ShareMenu.vue";
</script>

<template>
  <ActionMenuDropdown :action="selectionActions.share">
    <ShareMenu />
  </ActionMenuDropdown>
</template>
